import React from "react";
import { RefreshCw, Download, LogOut } from "lucide-react";

export default function AdminHeader({ loading, onRefresh, onExport, onLogout, hasItems }) {
  return (
    <header className="sticky top-0 z-10 bg-[#0e3a3f] text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <div>
          <div className="text-xs tracking-[3px] uppercase text-[#e8a04d] font-semibold">
            Administration
          </div>
          <h1 className="text-lg sm:text-xl font-serif">Demandes de contact CFMPE</h1>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onRefresh}
            disabled={loading}
            className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors disabled:opacity-50"
            title="Rafraîchir"
            data-testid="admin-refresh-btn"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
          </button>
          <button
            onClick={onExport}
            disabled={!hasItems}
            className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-[#e8a04d] hover:bg-[#d68e3b] text-[#0e3a3f] font-semibold text-sm disabled:opacity-50 transition-colors"
            data-testid="admin-export-btn"
          >
            <Download className="w-4 h-4" /> CSV
          </button>
          <button
            onClick={onLogout}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm transition-colors"
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">Déconnexion</span>
          </button>
        </div>
      </div>
    </header>
  );
}
